import { create } from 'zustand';
import { useNotificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { AuthApi, RequestStrategyEnum, type RecoveryRequest } from '@shared/api';
import { Constants } from '@shared/widgets';

interface UseRecoveryStore {
  error: string | null;
  success: boolean | null;
  loading: boolean;
  recovery: (request: RecoveryRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRecoveryStore = create<UseRecoveryStore>((set) => ({
  error: null,
  success: false,
  loading: false,

  recovery: ApiUtils.wrapperApi(async (request) => {
    try {
      set({ loading: true, success: null, error: null });
      await AuthApi.recovery(request);
      set({ success: true, loading: false });
      useNotificationStore.getState().setSuccess(Constants.RECOVERY_SUCCESS_MESSAGE);
    } catch (error) {
      set({ success: null, error: ApiUtils.getApiError(error), loading: false });
      useNotificationStore.getState().setError(Constants.DEFAULT_ERROR_MESSAGE);
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ error: null, success: false, loading: false }),
}));
